import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M15.75 5.26a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.911c-.563-.097-1.159.026-1.563.43L10.5 17.26H8.25v2.25H6v2.25H2.25v-2.818c0-.596.237-1.169.659-1.59l6.499-6.5c.404-.404.527-1 .43-1.563a6 6 0 1 1 11.912-1.03"
    }, null, -1)
  ])))
}
export default { render: render }